import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { EditorAuthService } from 'src/app/core/services/editor-auth.service';

/**
 * Blocks /cms (the Sitefinity Data Manager admin dashboard) for anyone not logged in as a
 * content editor, redirecting to /editor. Runs before PageResourcesResolver and before
 * CMSComponent is constructed, so no label/resource/setting data loads for non-editors.
 */
export const CmsEditorActivateGuard: CanActivateFn = (): boolean | UrlTree => {
  const editorAuthService = inject(EditorAuthService);
  const router = inject(Router);
  return editorAuthService.isLoggedIn() ? true : router.createUrlTree(['/editor']);
};
